angular.module('webtrader').component('trades', {
	bindings: {
		classes: '=',
	},
	templateUrl: (Account) => {
		if (Account.info.group.is_options)
			return BASE_URL+'templates/component.tradesOptions.html'
		return BASE_URL+'templates/component.trades.html'
	},
	controller: function (Quotes, Trades, Account) {
		this.account = Account
		this.quotes = Quotes
		this.trades = Trades

		this.closeOrder = (order) => {
			order.isLoading = true;
			this.trades.closeOrder(order.ticket).then(() => {
				order.close_time = new Date();
				order.options_data.expiration_time = moment();
				order.isLoading = false;
			}).then(() => {
				return this.trades.reloadTrades();
			}).catch(console.error);
		}
	}
})
